let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("f3U59")]).then(() => parcelRequire('fIQox'));